import React from "react";
import "./Terms.scss";

const Terms = () => {
  return (
    <div className="terms-container">
    
      <div className="terms-title"><h1>Terms and Conditions</h1>
        
      </div>
      <div className="terms-section">
        <h2 className="terms-section-title">Introduction</h2>
        <p className="terms-text">
          Welcome to <strong>Prathmesh Cyber Force Pvt Ltd</strong>. By accessing and using our website, you agree to comply with and be bound by the following terms and conditions. These terms govern your use of our website and the services we provide. If you disagree with any part of these terms, please refrain from using our website.
        </p>
      </div>

      <div className="terms-section">
        <h2 className="terms-section-title">Use of Website</h2>
        <p className="terms-text">
          The content provided on this website is for general information and personal use only. It is subject to change without notice. We do not guarantee the accuracy, completeness, or reliability of the information available on the site, and we reserve the right to modify, suspend, or discontinue any part of the website or services at any time without prior notice.
        </p>
      </div>

      <div className="terms-section">
        <h2 className="terms-section-title">Intellectual Property</h2>
        <p className="terms-text">
          All content, designs, logos, trademarks, text, images, and other materials found on this website are the intellectual property of <strong> Prathmesh Cyber Force Pvt Ltd</strong> and are protected by applicable copyright and trademark laws. You may not copy, reproduce, distribute, or use any materials from this website without prior written consent from us.
        </p>
      </div>

      <div className="terms-section">
        <h2 className="terms-section-title">Limitation of Liability</h2>
        <p className="terms-text">
          To the fullest extent permitted by law, <strong>Prathmesh Cyber Force Pvt Ltd</strong> shall not be liable for any direct, indirect, incidental, consequential, or punitive damages arising from your use or inability to use this website, including, but not limited to, errors, inaccuracies, interruptions, or any loss of data.
        </p>
      </div>

      <div className="terms-section">
        <h2 className="terms-section-title">Prohibited Uses</h2>
        <p className="terms-text">
          You agree not to use this website for any unlawful purpose or in a way that could damage, disable, overburden, or impair the website’s functionality or interfere with others' use of the site. This includes, but is not limited to, uploading harmful or malicious content, transmitting spam, or attempting unauthorized access to any part of the website or server.
        </p>
      </div>

      <div className="terms-section">
        <h2 className="terms-section-title">Indemnification</h2>
        <p className="terms-text">
          You agree to indemnify and hold <strong>Prathmesh Cyber Force Pvt Ltd</strong> harmless from any claims, damages, or expenses (including legal fees) arising from your violation of these terms and conditions or any actions related to your use of the website.
        </p>
      </div>

      <div className="terms-section">
        <h2 className="terms-section-title">Modifications to Terms</h2>
        <p className="terms-text">
          We reserve the right to update or modify these Terms and Conditions at any time. Any changes will be posted on this page, and the updated terms will take effect as soon as they are published. Your continued use of the website after any modifications constitutes your acceptance of the updated terms.
        </p>
      </div>

      <div className="terms-section">
        <h2 className="terms-section-title">Governing Law</h2>
        <p className="terms-text">
          These Terms and Conditions are governed by the laws of India. Any disputes arising from or related to the use of this website shall be subject to the exclusive jurisdiction of the courts in India.
        </p>
      </div>
    </div>
  );
};

export default Terms;
